module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_5511.24f4b6a7.jpg";